import React from 'react'
import { useLocation } from 'react-router-dom'; // Import useLocation
import { Box, Divider } from '@mui/material';
import { Footer, Hero } from '../components'; // Import Hero component
import { CareerJoin, CareerOpportunities, CareerDetails, CareerWhy, CareerBePart } from '../containers';

const Career = () => {
  const location = useLocation(); // Get the current location object
  const currentPath = location.pathname; // Extract the current path

  return (
    <Box
      sx={{
        width: '100%',
        minHeight: '100vh',
      }}
    >
      {/* Integrate the Hero component */}
      <Hero />

      {/* Render content based on the current path */}
      {currentPath === '/career' && (
        <>
          <CareerOpportunities />
          <Divider 
            sx={{
              paddingY: '2rem',
              '@media screen and (max-width: 762px)': {
                paddingY: '1rem',
              },
            }}
          />
            <CareerJoin />
        </>
      )}
      {currentPath === '/career/offers' && (
        <>
          <CareerDetails />
          <CareerWhy />
          <CareerBePart />
        </>
      )}
      <Footer />
    </Box>
  )
}

export default Career